export const FirebaseConfig = {
	apiKey: "AIzaSyAoRwX4o9snYfAZZNRtmdcV8381-XKmxhg",
	authDomain: "call7-fc147.firebaseapp.com",
	databaseURL: "https://call7-fc147-default-rtdb.firebaseio.com",
	projectId: "call7-fc147",
	storageBucket: "call7-fc147.appspot.com",
	messagingSenderId: "861440684659",
	appId: "1:861440684659:web:286799298382f473423006",
	measurementId: "G-2F5GSBS8TM",
};